import React from 'react';

const LoadingScreen = ({ text }) => {
  return (
    <div className='full-screen-loader'>{text}</div>
  )
}

export default LoadingScreen